import { Button, Group, Modal, Text } from "@mantine/core";

interface Props {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  mode: "create" | "view";
  scheduleEnabled: boolean;
}

export default function ConfirmNotificationModal({ opened, onClose, onConfirm, loading, mode, scheduleEnabled }: Props) {
  const title = mode === "view" ? "Update Notification" : scheduleEnabled ? "Create Notification" : "Send Instantly";
  const action = mode === "view" ? "update" : "create";

  return (
    <Modal opened={opened} onClose={onClose} title={title} centered size="sm">
      <Text fz="sm" c="dimmed" mb="lg">
        Are you sure you want to {action} this notification? This action cannot be undone.
      </Text>
      <Group justify="flex-end">
        <Button color="primary" onClick={onConfirm} loading={loading}>
          Confirm
        </Button>
      </Group>
    </Modal>
  );
}
